import React from "react";
import { Button } from "components/ui/button";
import { Card, CardHeader, CardContent, CardFooter, CardTitle, CardDescription } from "components/ui/card";

const Home = () => {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background text-center p-6">
      <Card className="w-full max-w-md shadow-md border border-border">
        <CardHeader>
          <CardTitle className="text-3xl font-bold text-primary">Welcome to Our Platform</CardTitle>
          <CardDescription className="text-muted-foreground mt-2">
            We are delighted to have you here! Explore our features and make the most of your experience.
          </CardDescription>
        </CardHeader>

        <CardContent>
          <p className="text-sm text-muted-foreground">
            Get started by navigating through the top menu and trying out our tools.
          </p>
        </CardContent>

        <CardFooter className="flex justify-center">
          <Button size="lg">Get Started</Button>
        </CardFooter>
      </Card>
    </div>
  );
};

export default Home;
